import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import VendorCategoryService from "../../../services/VendorCategoryService";
import Breadcrumb from "../../../components/Breadcrumb";
import ListVendorCategory from "../Components/ListVendorCategory";
import MessageDialog from "../../../components/MessageDialog";


export default function ViewVendorCategory() {
  const [vendorCategories, setVendorCategories] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO (single select)
  const [searchText, setSearchText] = useState(""); //  SEARCH
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(true);
  // const messageTimer = useRef(null);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const navigate = useNavigate();

  const fetchVendorCategories = async () => {
    setLoading(true);
    try {
      const res = await VendorCategoryService.getAll();
      const data = res.status === "true" ? res.data : [];

      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const paginatedData = data.slice(startIndex, endIndex);

      setVendorCategories(paginatedData);
      setPageCount(Math.ceil(data.length / itemsPerPage)); // ✅ use total data length
    } catch (err) {
      showMessage("Error fetching vendor categories.", "error");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchVendorCategories();
  }, [currentPage]);

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  //  RADIO SELECT
  const handleSelect = (id) => {
    setSelected(id);
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };


  const handleAdd = () => navigate("/cpnl/vendorcategory/add");

  const handleModify = () => {
    if (!selected) {
      showMessage("Select one vendor category to modify.");
      return;
    }
    navigate(`/cpnl/vendorcategory/add/${selected}`);
  };

  const handleToggleStatus = async (item) => {
    const newStatus = item.status === "Active" ? "InActive" : "Active";

    if (
      !window.confirm(
        `Are you sure do you want status change as ${newStatus}?`
      )
    )
      return;

    setLoading(true);
    try {
      await VendorCategoryService.toggleStatus(item.id);
      showMessage(`Status updated to ${newStatus}.`, "success");
      fetchVendorCategories();
    } catch (err) {
      showMessage("Error updating status.", "error");
    } finally {
      setLoading(false);
    }
  };

  //  FRONTEND SEARCH FILTER
  const filteredVendorCategories = vendorCategories.filter(
    (v) =>
      v.vendorCategoryName
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      v.vendorCategoryCode
        .toLowerCase()
        .includes(searchText.toLowerCase())
  );

  return (
    <>
      <Breadcrumb pageTitle="Vendor Categories" secondTitle="Masters" />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">

          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center mb-2 p-2`}
            >
              <span>{message}</span>
              <button
                type="button"
                className="btn-close"
                onClick={closeMessage}
              />
            </div>
          )} */}

          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          

          {/*  SEARCH + ACTION BUTTONS */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Vendor Category"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            <div className="ms-auto d-flex gap-2">
              <button
                className="btn btn-success"
                onClick={handleAdd}
                disabled={loading}
              >
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button
                className="btn btn-warning"
                onClick={handleModify}
                disabled={loading}
              >
                <i className="ti ti-pencil me-1"></i> Modify
              </button>
            </div>
          </div>

          {/*  TABLE */}
          <ListVendorCategory
            loading={loading}
            filteredVendorCategories={filteredVendorCategories}
            selected={selected}
            handleSelect={handleSelect}
            handleToggleStatus={handleToggleStatus}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />

        </div>
      </div>
    </>
  );
}